/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { createContext, useContext } from 'react';

import {
  type AccordionIsMultiple,
  type AccordionIsNotMultiple,
  type AccordionItemId,
} from './accordion-types';

type AccordionContextType<T extends AccordionItemId> =
  | Required<
      Pick<
        AccordionIsMultiple<T>,
        'onChange' | 'expandedItemIds' | 'isMultiple'
      >
    >
  | Required<
      Pick<
        AccordionIsNotMultiple<T>,
        'onChange' | 'expandedItemId' | 'isMultiple'
      >
    >;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AccordionContext = createContext<AccordionContextType<any> | null>(
  null,
);

export const useAccordionContext = () => {
  const context = useContext(AccordionContext);
  if (context === null) {
    throw new Error('Accordion used without context');
  }
  return context;
};
